import { formatCount, useServicesContext } from '@oneaudi/vtp-shared';
import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { useSelector } from 'react-redux';
import { SELECTORS } from '@oneaudi/stck-store';
import CountAndSort from './CountAndSort';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { getAppContentConfiguration } from '../../hooks/tileHook';

const ResultsBar: React.FC = () => {
  const content = getAppContentConfiguration();
  const localeService = useServicesContext().getAdditionalService(
    'gfa:locale-service'
  ) as LocaleServiceV1;
  const locale = `${localeService.language}-${localeService.countryCode}`;
  // Constants for Results
  const resultCountLabel = useI18n({ id: 'nemo.ui.sc.navig.hits', defaultMessage: '' });
  const totalResults = useSelector((state) => SELECTORS.VEHICLES.getTotalCountState(state));
  const formattedResultsCount = formatCount(totalResults, locale);
  // Constants for Favorites
  const favCountLabel = useI18n({ id: 'nemo.ui.sc.favorites', defaultMessage: '' });
  const totalFavs = useSelector((state) => SELECTORS.VEHICLES.getFavoriteVehicleIdsState(state));
  const formattedFavsCount = formatCount(totalFavs.length, locale);

  const countLabel = content?.appContext === 'results' ? resultCountLabel : favCountLabel;
  const formattedCount =
    content?.appContext === 'results' ? formattedResultsCount : formattedFavsCount;

  return <CountAndSort count={formattedCount} label={countLabel} />;
};

export default ResultsBar;
